import { makeAutoObservable, toJS } from 'mobx';
import { formatEmptyToNull } from '@utils/formatData';
import { LxSiteClick } from '@utils/siteLx';
import { LX_RESUME_EDIT_MODULE_ADD, LX_RESUME_EDIT_MODULE_DELETE } from '@common/const';

import {
  ICampusBaseInfo,
  ICampusEduExperience,
  ICampusWorkExperience,
  ICampusProjectExperience,
  ICampusHonor,
  ICampusLanguage,
  ICampusCertificate,
  ICampusSkill,
  ICampusPaper,
  ICampusCompetition,
  ICampusWorksAttachmentList,
  ICampusResumeAttachmentList,
  resumeBaseInfoDefault,
  resumeEduExpListDefault,
  resumeWorkExpListDefault,
  resumeProjectExpListDefault,
  resumeCampusExpListDefault,
  resumeHonorListDefault,
  resumeLanguageListDefault,
  resumeCertificateListDefault,
  resumeSkillListDefault,
  resumeThesisListDefault,
  resumeCompetitionListDefault,
  resumeAttachmentListDefault,
  ICampusCampusExperience,
} from '@/src/types/resumeDetail/campusType';

export default class CampusResumeDetail {
  constructor() {
    makeAutoObservable(this);
  }

  resumeUnionId: string;

  updateTime: number;

  resumeBaseInfo: ICampusBaseInfo;

  resumeEduExpList: ICampusEduExperience[];

  resumeWorkExpList: ICampusWorkExperience[];

  resumeProjectExpList: ICampusProjectExperience[];

  resumeCampusExpList: ICampusCampusExperience[];

  resumeHonorList: ICampusHonor[];

  resumeLanguageList: ICampusLanguage[];

  resumeCertificateList: ICampusCertificate[];

  resumeSkillList: ICampusSkill[];

  resumeThesisList: ICampusPaper[];

  resumeCompetitionList: ICampusCompetition[];

  resumeWorksAttachmentList: ICampusWorksAttachmentList[];

  resumeAttachmentList: ICampusResumeAttachmentList[];

  formatResumeKey: string;

  key = [
    'resumeBaseInfo',
    'resumeEduExpList',
    'resumeWorkExpList',
    'resumeProjectExpList',
    'resumeCampusExpList',
    'resumeHonorList',
    'resumeLanguageList',
    'resumeCertificateList',
    'resumeSkillList',
    'resumeThesisList',
    'resumeCompetitionList',
    'resumeWorksAttachmentList',
    'resumeAttachmentList',
  ];

  setStoreData = (resumeInfo) => {
    this.resumeUnionId = resumeInfo?.resumeUnionId;
    this.formatResumeKey = resumeInfo?.formatResumeKey;
    this.updateTime = resumeInfo?.resumeVo?.updateTime;
    if (resumeInfo?.resumeVo) {
      Object.keys(resumeInfo.resumeVo).forEach((key) => {
        if (resumeInfo.resumeVo[key] instanceof Array) {
          resumeInfo.resumeVo[key].forEach((item) => {
            item.renderId = Math.random();
          });
        }
        this[key] = resumeInfo.resumeVo[key];
      });
    } else {
      this.key.map((key) => {
        this[key] = null;
        return false;
      });
    }
  };

  // 修改基础信息
  setResumeBaseInfo = (fieldType, fieldValue) => {
    if (!this.resumeBaseInfo) this.resumeBaseInfo = resumeBaseInfoDefault;
    this.resumeBaseInfo[fieldType] = fieldValue;
  };

  // 修改简历字段
  setResumeAttachmentList = (fieldType, fieldValue) => {
    if (!this.resumeAttachmentList[0])
      this.resumeAttachmentList[0] = { ...resumeAttachmentListDefault, renderId: Math.random() };
    this.resumeAttachmentList[0][fieldType] = fieldValue;
  };

  // 修改证书
  setResumeCertificateList = (index, fieldType, fieldValue) => {
    if (!this.resumeCertificateList[index])
      this.resumeCertificateList[index] = { ...resumeCertificateListDefault, renderId: Math.random() };
    this.resumeCertificateList[index][fieldType] = fieldValue;
  };

  // 修改竞赛
  setResumeCompetitionList = (index, fieldType, fieldValue) => {
    if (!this.resumeCompetitionList[index])
      this.resumeCompetitionList[index] = { ...resumeCompetitionListDefault, renderId: Math.random() };
    this.resumeCompetitionList[index][fieldType] = fieldValue;
  };

  // 修改教育经历
  setResumeEduExpList = (index, fieldType, fieldValue) => {
    if (!this.resumeEduExpList[index])
      this.resumeEduExpList[index] = { ...resumeEduExpListDefault, renderId: Math.random() };
    this.resumeEduExpList[index][fieldType] = fieldValue;
  };

  // 修改荣誉
  setResumeHonorList = (index, fieldType, fieldValue) => {
    if (!this.resumeHonorList[index])
      this.resumeHonorList[index] = { ...resumeHonorListDefault, renderId: Math.random() };
    this.resumeHonorList[index][fieldType] = fieldValue;
  };

  // 修改语言水平
  setResumeLanguageList = (index, fieldType, fieldValue) => {
    if (!this.resumeLanguageList[index])
      this.resumeLanguageList[index] = { ...resumeLanguageListDefault, renderId: Math.random() };
    this.resumeLanguageList[index][fieldType] = fieldValue;
  };

  // 修改论文水平
  setResumeThesisList = (index, fieldType, fieldValue) => {
    if (!this.resumeThesisList[index])
      this.resumeThesisList[index] = { ...resumeThesisListDefault, renderId: Math.random() };
    this.resumeThesisList[index][fieldType] = fieldValue;
  };

  // 修改项目经历
  setResumeProjectExpList = (index, fieldType, fieldValue) => {
    if (!this.resumeProjectExpList[index])
      this.resumeProjectExpList[index] = { ...resumeProjectExpListDefault, renderId: Math.random() };
    this.resumeProjectExpList[index][fieldType] = fieldValue;
  };

  // 修改校园经历
  setResumeCampusExpList = (index, fieldType, fieldValue) => {
    if (!this.resumeCampusExpList[index])
      this.resumeCampusExpList[index] = { ...resumeCampusExpListDefault, renderId: Math.random() };
    this.resumeCampusExpList[index][fieldType] = fieldValue;
  };

  // 修改技能水平
  setResumeSkillList = (index, fieldType, fieldValue) => {
    if (!this.resumeSkillList[index])
      this.resumeSkillList[index] = { ...resumeSkillListDefault, renderId: Math.random() };
    this.resumeSkillList[index][fieldType] = fieldValue;
  };

  // 修改工作经历
  setResumeWorkExpList = (index, fieldType, fieldValue) => {
    if (!this.resumeWorkExpList[index])
      this.resumeWorkExpList[index] = { ...resumeWorkExpListDefault, renderId: Math.random() };
    this.resumeWorkExpList[index][fieldType] = fieldValue;
  };

  // 增加默认模块
  addResumeList = (type: string, data?: any) => {
    LxSiteClick({ bid: LX_RESUME_EDIT_MODULE_ADD[type], valLab: { resumeType: 'campus' } });
    if (type === 'resumeEduExpList') {
      if (!this.resumeEduExpList) this.resumeEduExpList = [];
      this.resumeEduExpList.push({ ...resumeEduExpListDefault, renderId: Math.random() });
    }
    if (type === 'resumeWorkExpList') {
      if (!this.resumeWorkExpList) this.resumeWorkExpList = [];
      this[type].push({ ...resumeWorkExpListDefault, renderId: Math.random() });
    }
    if (type === 'resumeProjectExpList') {
      if (!this.resumeProjectExpList) this.resumeProjectExpList = [];
      this[type].push({ ...resumeProjectExpListDefault, renderId: Math.random() });
    }
    if (type === 'resumeCampusExpList') {
      if (!this.resumeCampusExpList) this.resumeCampusExpList = [];
      this[type].push({ ...resumeCampusExpListDefault, renderId: Math.random() });
    }
    if (type === 'resumeHonorList') {
      if (!this.resumeHonorList) this.resumeHonorList = [];
      this[type].push({ ...resumeHonorListDefault, renderId: Math.random() });
    }
    if (type === 'resumeLanguageList') {
      if (!this.resumeLanguageList) this.resumeLanguageList = [];
      this[type].push({ ...resumeLanguageListDefault, renderId: Math.random() });
    }
    if (type === 'resumeCertificateList') {
      if (!this.resumeCertificateList) this.resumeCertificateList = [];
      this[type].push({ ...resumeCertificateListDefault, renderId: Math.random() });
    }
    if (type === 'resumeSkillList') {
      if (!this.resumeSkillList) this.resumeSkillList = [];
      this[type].push({ ...resumeSkillListDefault, renderId: Math.random() });
    }
    if (type === 'resumeThesisList') {
      if (!this.resumeThesisList) this.resumeThesisList = [];
      this[type].push({ ...resumeThesisListDefault, renderId: Math.random() });
    }
    if (type === 'resumeCompetitionList') {
      if (!this.resumeCompetitionList) this.resumeCompetitionList = [];
      this[type].push({ ...resumeCompetitionListDefault, renderId: Math.random() });
    }
    if (type === 'resumeWorksAttachmentList') {
      if (!this.resumeWorksAttachmentList) this.resumeWorksAttachmentList = [];
      this[type].push({ ...data, renderId: Math.random() });
    }
    if (type === 'resumeAttachmentList') {
      if (!this.resumeAttachmentList) this.resumeAttachmentList = [];
      this[type].push({ ...data, renderId: Math.random() });
    }
  };

  // 减少模块
  deleteResumeList = (type: string, index: number) => {
    LxSiteClick({ bid: LX_RESUME_EDIT_MODULE_DELETE[type], valLab: { resumeType: 'campus' } });
    this[type].splice(index, 1);
  };

  // 获取所有数据
  getAllData = () => {
    const param = {
      resumeBaseInfo: this.resumeBaseInfo,
      resumeEduExpList: this.resumeEduExpList,
      resumeWorkExpList: this.resumeWorkExpList,
      resumeProjectExpList: this.resumeProjectExpList,
      resumeCampusExpList: this.resumeCampusExpList,
      resumeHonorList: this.resumeHonorList,
      resumeLanguageList: this.resumeLanguageList?.map((item) => ({
        ...item,
        examinationId: item?.language === 'English' ? item?.examinationId : null,
        examinationName: item?.language === 'English' ? item?.examinationName : null,
        score: item?.language === 'English' ? item?.score : null,
      })),
      resumeCertificateList: this.resumeCertificateList,
      resumeSkillList: this.resumeSkillList,
      resumeThesisList: this.resumeThesisList,
      resumeCompetitionList: this.resumeCompetitionList,
      resumeWorksAttachmentList: this.resumeWorksAttachmentList,
      resumeAttachmentList: this.resumeAttachmentList,
    };
    return {
      resumeUnionId: this.resumeUnionId,
      formatResumeKey: this.formatResumeKey,
      updateTime: new Date().getTime(),
      resumeVo: formatEmptyToNull(toJS(param)),
    };
  };
}
